<template>
  <v-card flat dense>
    <v-card-title>
      <div class="d-inline-flex align-baseline">
        <span class="text-h5">{{ $t('APARTMENTS.CHECKOUT') }}</span>
      </div>
      <v-spacer></v-spacer>
      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <check-out
          v-model="checkOutData"
          :errors="errors.getAll()"
          @update-prop="clearErrorByName($event)"
        />
      </v-form>
    </v-card-text>

    <v-card-actions>
      <slot name="buttons" :valid="valid" :cancel="cancel" :update="update">
        <v-btn large outlined depressed color="grey" @click="cancel">{{
          $t('BUTTON.CANCEL')
        }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          large
          depressed
          color="primary"
          :disabled="!valid"
          @click="update"
        >
          {{ $t('BUTTON.UPDATE') }}
        </v-btn>
      </slot>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import { isEqual, cloneDeep } from 'lodash';
import errors from '@/modules/_global/mixins/errors';
import CheckOut from '@/modules/persons/components/forms/CheckOut';
import { onceRequest } from '@/modules/_global/utils/common';

export default {
  name: 'CheckOutCard',

  components: {
    CheckOut
  },

  mixins: [errors],

  model: {
    prop: 'person'
  },

  props: {
    person: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    valid: true,
    localPerson: {},
    result: {}
  }),

  computed: {
    checkOutData: {
      get() {
        return {
          person: this.localPerson,
          inhabitant: this.localPerson.inhabitant
        };
      },
      set(v) {
        this.result = v;
      }
    }
  },

  watch: {
    person: {
      deep: true,
      immediate: true,
      handler: function(person) {
        if (isEqual(person, this.localPerson)) {
          return;
        }

        this.localPerson = {
          ...this.localPerson,
          ...cloneDeep(person)
        };
      }
    }
  },

  mounted() {},

  methods: {
    ...mapActions('inhabitant', ['checkOut']),

    update: onceRequest(function update() {
      if (!this.$refs.form.validate()) {
        return;
      }

      return this.checkOut({ id: this.result.inhabitant.id, data: this.result })
        .then(({ data }) => {
          this.localPerson.inhabitant = data.data;
          this.$emit('input', this.localPerson);
          this.$emit('update');
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    }),

    cancel() {
      this.$emit('cancel');
    }
  }
};
</script>
